/* eslint-disable multiline-ternary */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { connect } from 'itty-sockets'
import React, {
  useState,
  type ReactElement,
  useEffect,
  useRef,
  useMemo
} from 'react'
import {
  Input,
  InputGroup,
  InputLeftAddon,
  Box,
  Button,
  Heading,
  IconButton,
  Flex,
  FormLabel,
  FormHelperText,
  FormErrorMessage,
  FormControl,
  Grid,
  Select,
  Spinner,
  Text,
  Checkbox
} from '@chakra-ui/react'
import { ArrowUpIcon } from '@chakra-ui/icons'
import EmojiPicker, { EmojiStyle } from 'emoji-picker-react'

import { profanity } from '@2toad/profanity'
import { Nostalgist, type Nostalgist as NostalgistType } from 'nostalgist'
import CryptoJS, { MD5 } from 'crypto-js'
import PlayAlong from './Playalong'
import VideoArmageddon from './VideoArmageddon'
import JoinView from './views/JoinView'

import 'mapbox-gl/dist/mapbox-gl.css'

import { ErrorModal } from '../../components/Modals'

let tempChannel: any

const Page: React.FC = (data) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [roomCode, setRoomCode] = useState('')
  const [playerName, setPlayerName] = useState('')
  const [mode, setMode] = useState('login')
  const [channel, setChannel] = useState<any>()
  const [clientInfo, setClientInfo] = useState({})
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const LobbyView: React.FC = () => {
    return (
      <Flex
        flexDir="column"
        display={phase === 'waiting' ? 'flex' : 'none'}
        alignItems="center"
      >
        <Box>
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Box>
        <Heading
          fontWeight={800}
          letterSpacing={'-0.05em'}
          textAlign="center"
          mb="20px"
        >
          Waiting to start...
        </Heading>
      </Flex>
    )
  }

  // Fireworks views and functions
  const FireworksView: React.FC = () => {
    return (
      <Flex sx={styles.container}>
        <Button
          colorScheme="teal"
          w="80vw"
          h="auto"
          aspectRatio="1/1"
          maxW="280px"
          borderRadius="80vw"
          mx="auto"
          fontSize="72px"
          onClick={() => {
            sendFireworks()
          }}
        >
          Fire!
        </Button>
      </Flex>
    )
  }

  const sendFireworks = (): void => {
    if (channel != null) {
      channel.send('send')
    }
  }

  // Start Stop Continue Section

  const StartStopContinueView = (): ReactElement => {
    const [description, setDescription] = useState<string>('')

    const sendNote = (type: string, description: string): void => {
      if (channel != null && description !== '') {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          type,
          description
        })
        setDescription('')
      }
    }

    return (
      <Flex sx={styles.container}>
        <FormLabel>
          What would you like to write?
          <FormControl sx={styles.inputWrapper}>
            <Input
              value={description}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setDescription(event.target.value)
              }}
            />
            <div className="bend" />
          </FormControl>
        </FormLabel>
        <Grid templateColumns="1fr 1fr 1fr" gap="16px">
          <Button
            bg="green.300"
            onClick={() => {
              sendNote('start', description)
            }}
          >
            Start
          </Button>
          <Button
            bg="red.300"
            onClick={() => {
              sendNote('stop', description)
            }}
          >
            Stop
          </Button>
          <Button
            bg="yellow.300"
            onClick={() => {
              sendNote('continue', description)
            }}
          >
            Continue
          </Button>
        </Grid>
      </Flex>
    )
  }
  // Up for discussion Section

  const UpForDiscussionView = (): ReactElement => {
    const [question, setQuestion] = useState<string>('')
    const [questionList, setQuestionList] = useState<any[]>([])

    const sendQuestion = (question: string): void => {
      if (channel != null && question !== '') {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          type: 'question',
          question
        })
        setQuestion('')
      }
    }
    const sendVote = (id: string, voteType: string): void => {
      if (channel != null) {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          type: 'vote',
          voteId: id,
          voteType
        })
        setQuestionList((prevValue) => {
          const tempQuestions = [...prevValue]
          const objWithIdIndex = tempQuestions.findIndex((obj) => obj.id === id)
          if (objWithIdIndex > -1) {
            tempQuestions[objWithIdIndex].votes = tempQuestions[
              objWithIdIndex
            ].votes.filter((e: string) => e !== playerName)
            if (voteType === 'up') {
              tempQuestions[objWithIdIndex].votes.push(playerName)
            }
          }
          return tempQuestions
        })
      }
    }

    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'updateQuestionList':
          setQuestionList(message.questions)
          break
        default:
      }
    }

    useEffect(() => {
      channel?.on('message', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        <Box flexGrow="inherit" overflowY="auto">
          <Box as="ul">
            {questionList
              .filter((item) => item.archived === false)
              .map((item: any, index: number) => {
                return (
                  <Flex
                    as="li"
                    key={item.id}
                    gap="10px"
                    mb="10px"
                    alignItems="center"
                  >
                    <IconButton
                      bg={
                        item.votes.includes(playerName) === true
                          ? 'green.300'
                          : 'none'
                      }
                      border="1px solid currentcolor"
                      aria-label="Upvote this question"
                      icon={<ArrowUpIcon />}
                      onClick={() => {
                        sendVote(
                          item.id,
                          item.votes.includes(playerName) === true
                            ? 'down'
                            : 'up'
                        )
                      }}
                    />
                    <Text mb="0">{item.question}</Text>
                  </Flex>
                )
              })}
          </Box>
        </Box>
        <Box>
          <FormLabel>
            Submit Question
            <FormControl sx={styles.inputWrapper}>
              <Input
                value={question}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setQuestion(event.target.value)
                }}
              />
              <div className="bend" />
            </FormControl>
          </FormLabel>
          <Button
            bg="green.300"
            onClick={() => {
              sendQuestion(question)
            }}
          >
            Submit Question
          </Button>
        </Box>
      </Flex>
    )
  }

  interface ClientPostItData {
    text: string
    color: string
    display?: string
    fontSize?: string
    textAlign?: string
    style?: any
    onClick?: any
  }

  const ClientPostIt: React.FC<ClientPostItData> = (props) => {
    const maxAngle = 5
    const [rotations] = useState(0 - maxAngle + Math.random() * 2 * maxAngle)
    const {
      color,
      display = '-webkit-box',
      fontSize = '',
      text,
      textAlign = 'left',
      style,
      onClick
    } = props
    const bgColors = {
      start: 'green.300',
      stop: 'red.300',
      continue: 'yellow.300'
    }[color]
    const FinalFontSize: string =
      fontSize !== ''
        ? fontSize
        : `clamp(5vw,calc(1.5vw + (40vw / ${
            text.length < 3 ? 3 : text.length
          })), 100px)`

    return (
      <Box as="button" onClick={onClick}>
        <Box
          sx={{
            bg: bgColors,
            boxShadow: '2px 2px 5px rgba(0,0,0,0.5)',
            aspectRatio: '1',
            width: '90%',
            mx: 'auto',
            mb: '10px',
            p: '20px',
            transition: 'all 500ms ease',
            transform: `rotate(${rotations}deg)`,
            pos: 'relative',
            fontFamily: 'Kalam, cursive'
          }}
          style={style}
        >
          <Box
            sx={{
              overflow: 'hidden',
              maxH: '10em',
              display,
              lineHeight: '1.25em',
              textAlign
            }}
            style={{
              fontSize: FinalFontSize
            }}
          >
            {text}
          </Box>
        </Box>
      </Box>
    )
  }

  const TwoTruthsAndALie = (): ReactElement => {
    const [submission, setSubmission] = useState<any[]>([
      {
        text: '',
        truth: true,
        votes: []
      },
      {
        text: '',
        truth: true,
        votes: []
      },
      {
        text: '',
        truth: false,
        votes: []
      }
    ])
    const [vote, setVote] = useState<number | null>(null)
    const [phase, setPhase] = useState<string>('submissions')
    const [factPhase, setFactPhase] = useState<number>(0)
    const [hideForm, setHideForm] = useState<boolean>(false)

    // const [currentVote, setCurrentVote] = useState<any | null>(null)

    const sendsubmission = (): void => {
      if (channel != null) {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          type: 'submission',
          submission: submission.sort((a: any, b: any) => Math.random() - 0.5)
        })
        setPhase('waiting')
      }
    }

    const changeSubmissionText = (index: number, value: string): void => {
      setSubmission((prevValue: any[]): any => {
        prevValue[index].text = value
        return [...prevValue]
      })
    }

    const sendVote = (index: number): void => {
      if (channel != null) {
        setVote(index)
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          type: 'vote',
          vote: index
        })
      }
    }

    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'nextVote':
          setVote(null)
          setPhase('voting')
          break
        default:
      }
    }

    const nextVotePhase = (phaseNumber: number): void => {
      setHideForm(true)
      setTimeout(() => {
        setFactPhase(phaseNumber)
        setHideForm(false)
      }, 500)
    }

    useEffect(() => {
      channel?.on('message', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        {/* Fact submission */}
        <Box display={phase === 'submissions' ? 'block' : 'none'}>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Submit your {'"'}Facts{'"'}
          </Heading>
          <Box
            opacity={hideForm ? 0 : 1}
            display={factPhase === 0 ? 'block' : 'none'}
            transition="all 500ms ease"
          >
            <FormLabel>
              <Text textAlign="center">First Truth</Text>
              <FormControl sx={styles.inputWrapper}>
                <Input
                  value={submission[0].text}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    changeSubmissionText(0, event.target.value)
                  }}
                />
                <div className="bend" />
              </FormControl>
            </FormLabel>
            <Button
              colorScheme="teal"
              w="100%"
              isDisabled={submission[0].text === ''}
              onClick={() => {
                nextVotePhase(1)
              }}
            >
              Next
            </Button>
          </Box>
          <Box
            opacity={hideForm ? 0 : 1}
            display={factPhase === 1 ? 'block' : 'none'}
          >
            <FormLabel>
              <Text textAlign="center">Second Truth</Text>
              <FormControl sx={styles.inputWrapper}>
                <Input
                  value={submission[1].text}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    changeSubmissionText(1, event.target.value)
                  }}
                />
                <div className="bend" />
              </FormControl>
            </FormLabel>
            <Button
              colorScheme="teal"
              w="100%"
              isDisabled={submission[1].text === ''}
              onClick={() => {
                nextVotePhase(2)
              }}
            >
              Next
            </Button>
          </Box>
          <Box
            opacity={hideForm ? 0 : 1}
            display={factPhase === 2 ? 'block' : 'none'}
          >
            <FormLabel>
              <Text textAlign="center">Lie</Text>
              <FormControl sx={styles.inputWrapper}>
                <Input
                  value={submission[2].text}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    changeSubmissionText(2, event.target.value)
                  }}
                />
                <div className="bend" />
              </FormControl>
            </FormLabel>
            <Button
              colorScheme="teal"
              w="100%"
              isDisabled={submission[2].text === ''}
              onClick={() => {
                sendsubmission()
              }}
            >
              Submit Question
            </Button>
          </Box>
        </Box>
        {/* End Fact submission */}

        {/* Vote */}
        <Flex flexDir="column" display={phase === 'voting' ? 'flex' : 'none'}>
          <Box w="100%">
            <Grid templateColumns={'1fr 1fr 1fr'}>
              {[0, 1, 2].map((index) => {
                return (
                  <ClientPostIt
                    key={'clientPostIt' + index.toString()}
                    text={(index + 1).toString()}
                    display="inline"
                    color={vote === index ? 'stop' : 'continue'}
                    textAlign="center"
                    onClick={() => {
                      sendVote(index)
                    }}
                  />
                )
              })}
            </Grid>
          </Box>
        </Flex>
        {/* End Vote */}

        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'waiting' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Waiting to start...
          </Heading>
        </Flex>
        {/* End Vote */}
      </Flex>
    )
  }

  // Up for discussion Section

  const VibeCheck = (): ReactElement => {
    const sendEmoji = (emoji: string): void => {
      if (channel != null && emoji !== '') {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          type: 'emoji',
          emoji
        })
      }
    }

    const triggerAction = (message: any): void => {}

    useEffect(() => {
      channel?.on('message', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        <Box flexGrow="inherit" overflowY="auto">
          <FormLabel>
            Send Emoji
            <EmojiPicker
              onEmojiClick={(newEmoji) => {
                sendEmoji(newEmoji.emoji)
              }}
              emojiStyle={EmojiStyle.NATIVE}
              emojiVersion="5.0"
            />
          </FormLabel>
        </Box>
      </Flex>
    )
  }

  const EmojiMirror = (): ReactElement => {
    const [players, setPlayers] = useState<any[]>([])
    const [guess, setGuess] = useState<string | null>(null)
    const [phase, setPhase] = useState<string>('waiting')
    const [factPhase, setFactPhase] = useState<number>(0)
    const [hideForm, setHideForm] = useState<boolean>(false)

    // const [currentVote, setCurrentVote] = useState<any | null>(null)

    const sendGuess = (): void => {
      if (channel != null) {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          type: 'guess',
          guess
        })
      }
    }
    const nextResultsPhase = (phaseNumber: number): void => {
      setPhase('waiting')
    }
    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'updatePlayerList':
          setPlayers(message.players)
          setPhase('guessing')
          break
        case 'showResults':
          setPhase('results')
          break
        default:
      }
    }

    useEffect(() => {
      channel?.on('message', (message: any) => {
        triggerAction(message)
      })
    }, [])

    useEffect(() => {
      sendGuess()
    }, [guess])

    const currentEmoji =
      players.find((player) => {
        return player.name === playerName
      })?.emoji ?? ''

    return (
      <Flex sx={styles.container}>
        {/* Guess */}
        <Box display={phase === 'guessing' ? 'block' : 'none'}>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Your Emoji
          </Heading>
          <Text textAlign="center" fontSize="84px">
            {currentEmoji}
          </Text>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Guess your mirror
          </Heading>

          <Select
            value={guess ?? ''}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              setGuess(e.target.value)
            }}
          >
            <option value="">Select a Player</option>
            {players
              .filter((player) => {
                return player.name !== playerName
              })
              .map((player, index) => {
                return (
                  <option key={`player-${index}`} value={player.name}>
                    {player.name}
                  </option>
                )
              })}
          </Select>
        </Box>
        {/* End Guess */}

        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'waiting' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Waiting to start...
          </Heading>
        </Flex>
        {/* End Waiting */}
        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'results' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Look at Screen
          </Heading>
        </Flex>
        {/* End Waiting */}
      </Flex>
    )
  }

  interface MarkerType {
    longitude: number
    latitude: number
  }

  const Impaintient = (): ReactElement => {
    const [phase, setPhase] = useState<string>('waiting')
    const [guess, setGuess] = useState<string>('')
    const [tries, setTries] = useState<number>(2)
    const [correctGuess, setCorrectGuess] = useState<string | null>(null)
    const sendGuess = (): void => {
      if (channel != null) {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          type: 'guess',
          guess
        })
        setPhase('waiting')
      }
    }

    const triggerAction = (message: any): void => {
      switch (message.action) {
        case 'currentRound':
          setCorrectGuess(atob(message.data.word))
          setPhase('guessing')
          break
        case 'nextRound':
          setGuess('')
          setCorrectGuess(atob(message.data.word))
          setTries(2)
          setPhase('guessing')
          break
        case 'showResults':
          setPhase('results')
          break
        default:
      }
    }

    useEffect(() => {
      if (guess.toLowerCase() === correctGuess?.toLowerCase()) {
        sendGuess()
      }
    }, [guess])

    useEffect(() => {
      if (tries === 0) {
        setPhase('waiting')
      }
    }, [tries])

    useEffect(() => {
      channel?.on('message', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        {/* Guess */}
        <Flex
          pos="relative"
          alignItems="center"
          flexDir="column"
          justifyContent="center"
          h="100%"
          display={phase === 'guessing' ? 'flex' : 'none'}
        >
          <FormControl isInvalid={tries < 2} sx={styles.inputWrapper}>
            <FormLabel>
              <Text textAlign="center"></Text>
              <Heading
                fontWeight={800}
                letterSpacing={'-0.05em'}
                textAlign="center"
                mb="0px"
              >
                Guess The Item <br />
                On Screen
              </Heading>
              <Text textAlign="center" fontSize="14px">
                You Only Get 2 Tries
              </Text>
              {correctGuess !== null && (
                <Box pos="relative">
                  <Input
                    value={guess ?? ''}
                    placeholder="Type One Letter at a Time"
                    disabled={tries === 0}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      let correct = true
                      for (let i = 0; i < event.target.value.length; i++) {
                        if (
                          correctGuess !== null &&
                          event.target.value[i].toLowerCase() !==
                            correctGuess[i].toLowerCase()
                        ) {
                          correct = false
                          break
                        }
                      }
                      if (correct) {
                        setGuess(event.target.value)
                      } else {
                        setTries((prevValue) => {
                          return prevValue - 1
                        })
                      }
                    }}
                  />
                  <div className="bend" />
                </Box>
              )}
            </FormLabel>
            {tries === 1 && (
              <FormErrorMessage>Wrong Letter, Last Chance</FormErrorMessage>
            )}
            {tries === 0 && <FormErrorMessage>Wrong</FormErrorMessage>}
            {correctGuess !== null && guess === correctGuess && (
              <FormHelperText>Correct Answer</FormHelperText>
            )}
          </FormControl>
          {/* <Button
            pos="absolute"
            inset="auto 30px 30px"
            colorScheme="teal"
            isDisabled={guess === '' || tries === 0}
            onClick={() => {
              sendGuess()
            }}
            zIndex="10"
          >
            Send Guess
          </Button> */}
        </Flex>
        {/* End Guess */}

        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'waiting' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            {tries === 0 && 'Wrong'}
            {tries > 0 && guess !== '' && 'Correct Answer'}
          </Heading>
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Waiting for next round...
          </Heading>
        </Flex>
        {/* End Waiting */}
        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === 'results' ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Look at Screen
          </Heading>
        </Flex>
        {/* End Waiting */}
      </Flex>
    )
  }

  enum PlayerState {
    SETUP,
    WAITING,
    DRAWING,
    GUESSING
  }

  const pieces = ['💀', '👠', '📯', '🧸', '🍦']

  const Quietro = (): ReactElement => {
    const [phase, setPhase] = useState<PlayerState>(PlayerState.WAITING)
    const [maxBots, setMaxBots] = useState<number>(0)
    const [difficulty, setDifficulty] = useState<number>(0)
    const [guess, setGuess] = useState<string>('')
    const [correctLetters, setCorrectLetters] = useState<string>('')
    const [tries, setTries] = useState<number>(2)
    const [playerNumber, setPlayerNumber] = useState<number>(0)
    const guessInputRef = useRef<HTMLInputElement>(null)

    const startGame = (): void => {
      if (channel != null) {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          action: 'start',
          maxBots,
          difficulty
        })
        setPhase(PlayerState.WAITING)
      }
    }

    const sendGuess = (): void => {
      if (channel != null) {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          action: 'guess',
          guess
        })
        setPhase(PlayerState.WAITING)
      }
    }

    const sendBuzzer = (): void => {
      if (channel != null) {
        channel.send({
          id: channel.myID,
          clientId: channel.myAlias,
          action: 'buzz'
        })
        // setPhase(PlayerState.WAITING)
      }
    }

    const triggerAction = (message: any): void => {
      if (message.self) return
      let playerIndex: number
      switch (message.action) {
        case 'players':
          playerIndex = message.players.findIndex(
            (player: { clientId: any }) => {
              return player.clientId === channel?.myAlias
            }
          )
          if (playerIndex === -1) {
            return
          }

          setPlayerNumber(playerIndex + 1)
          if (playerIndex === 0) {
            setPhase(PlayerState.SETUP)
          }
          break
        case 'phase':
          if (message.phase === 'DRAWING') {
            setGuess('')
            setCorrectLetters('')
          }
          setPhase(PlayerState[message.phase] as unknown as PlayerState)
          break

        case 'buzzed_in':
          if (message.buzzedIn === channel?.myAlias) {
            setGuess('')
            setCorrectLetters('')
            setPhase(PlayerState.GUESSING)
            guessInputRef.current?.focus()
          } else {
            setPhase(PlayerState.WAITING)
          }
          break

        case 'reset_tries':
          setTries(2)
          break

        case 'wrong_guess':
          if (message.buzzedIn === channel?.myAlias) {
            setTries((prevValue) => {
              return prevValue - 1
            })
            setGuess('')

            if (tries === 2) {
              setCorrectLetters(message.correctLetters)
              setPhase(PlayerState.GUESSING)
            } else {
              setPhase(PlayerState.WAITING)
            }
          }
          break
        case 'short_guess':
          if (message.buzzedIn === channel?.myAlias) {
            setCorrectLetters(message.correctLetters)
            setGuess('')
            setPhase(PlayerState.GUESSING)
          }
          break
        default:
      }
    }

    useEffect(() => {
      channel?.on('message', (message: any) => {
        triggerAction(message)
      })
    }, [])

    return (
      <Flex sx={styles.container}>
        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === PlayerState.SETUP ? 'flex' : 'none'}
          alignItems="center"
        >
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            Player 1, Please select the game options
          </Heading>
          <FormLabel w="100%">
            Max Number of Computer Players
            <Select
              w="100%"
              value={maxBots}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                setMaxBots(parseInt(e.target.value))
              }}
            >
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </Select>
          </FormLabel>
          <FormLabel w="100%">
            Select Skill Level
            <Select
              w="100%"
              value={difficulty}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                setDifficulty(parseInt(e.target.value))
              }}
            >
              <option value="0">Easy</option>
              <option value="1">Medium</option>
              <option value="2">Hard</option>
              <option value="3">Very Hard</option>
            </Select>
          </FormLabel>
          <Button
            colorScheme="teal"
            onClick={() => {
              startGame()
            }}
            zIndex="10"
          >
            Start Game
          </Button>
        </Flex>
        {/* End Waiting */}

        {/* Waiting */}
        <Flex
          flexDir="column"
          display={phase === PlayerState.WAITING ? 'flex' : 'none'}
          alignItems="center"
        >
          <Box>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Box>
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            {playerNumber > 0 && (
              <>
                You are Player {playerNumber} {pieces[playerNumber]}{' '}
              </>
            )}
            <br />
            Look at the screen
          </Heading>
        </Flex>
        {/* End Waiting */}

        {/* Drawing */}

        <Flex
          flexDir="column"
          display={phase === PlayerState.DRAWING ? 'flex' : 'none'}
          alignItems="center"
        >
          <Heading
            fontWeight={800}
            letterSpacing={'-0.05em'}
            textAlign="center"
            mb="20px"
          >
            You are Player {playerNumber} {pieces[playerNumber]}
            <br />
            {tries === 2 && <> Buzz in if you Know The Word </>}
            {tries === 0 && <> Out of Guesses </>}
          </Heading>
          <Button
            display={tries === 2 ? 'block' : 'none'}
            w="50%"
            h="auto"
            aspectRatio={1}
            borderRadius="100%"
            colorScheme="red"
            border="3px solid black"
            boxShadow={'2px 2px 5px rgba(0,0,0,0.5)'}
            onClick={() => {
              sendBuzzer()
            }}
          ></Button>
        </Flex>

        {/* End Drawing */}

        {/* Guessing */}
        <Flex
          pos="relative"
          alignItems="center"
          flexDir="column"
          justifyContent="center"
          h="100%"
          display={phase === PlayerState.GUESSING ? 'flex' : 'none'}
        >
          <FormControl sx={styles.inputWrapper}>
            <FormLabel>
              <Text textAlign="center"></Text>
              <Heading
                fontWeight={800}
                letterSpacing={'-0.05em'}
                textAlign="center"
                mb="0px"
              >
                Guess The Item On Screen
                <br />
                {tries === 2 && 'You Have 2 Tries'}
                {tries < 2 && 'Last Chance'}
              </Heading>

              <Box pos="relative">
                <Input
                  ref={guessInputRef}
                  isInvalid={guess.length === 0}
                  value={correctLetters + guess}
                  onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === 'Enter') {
                      sendGuess()
                    }
                  }}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setGuess(
                      event.target.value
                        .slice(correctLetters.length)
                        .replace(/[^a-zA-Z\s]/g, '')
                        .toUpperCase()
                    )
                  }}
                />
                <div className="bend" />
              </Box>
            </FormLabel>
            {tries === 1 && <FormErrorMessage>Last Chance</FormErrorMessage>}
          </FormControl>
          <Button
            w="100%"
            colorScheme="teal"
            isDisabled={guess === ''}
            onClick={() => {
              sendGuess()
            }}
            zIndex="10"
          >
            Send Guess
          </Button>
        </Flex>
        {/* End Guess */}
      </Flex>
    )
  }

  const joinRoom = (newClientInfo: {
    playerName: string
    roomCode: string
    hasLobby?: boolean
  }): void => {
    if (profanity.exists(newClientInfo.playerName)) {
      setErrorMessage(
        `Really? "${newClientInfo.playerName}" is your name? Let's try that again. `
      )
      return
    }
    setPlayerName(newClientInfo.playerName)
    setRoomCode(newClientInfo.roomCode)
    tempChannel = connect(
      'reactvts-' +
        newClientInfo.roomCode +
        (newClientInfo.playerName === 'director' || newClientInfo.hasLobby
          ? '-game'
          : ''),
      {
        as: newClientInfo.playerName,
        announce: true,
        list: true
      }
    )

    tempChannel.on('join', function ({ self, users, uid }: any) {
      if (!self) return
      const lobbyUser = users.find(({ alias }: { alias: string }) => {
        return alias.includes('lobby-')
      })
      const serverUser = users.find(({ alias }: { alias: string }) => {
        return alias.includes('server-')
      })

      if (serverUser === undefined && lobbyUser === undefined) {
        tempChannel.close()
        setErrorMessage('Room Code is incorrect or the room no longer exists.')
      } else {
        tempChannel.on('client-message_full', function (message: any) {
          if (message.clientId === newClientInfo.playerName) {
            setErrorMessage('Room is full, please try again later.')
            tempChannel.close()
            setMode('login')
          }
        })
        tempChannel.myAlias = newClientInfo.playerName
        tempChannel.myID = uid
        if (lobbyUser) {
          tempChannel.on('client-message_let_in', () => {
            tempChannel.close()
            joinRoom({
              playerName: newClientInfo.playerName,
              roomCode: newClientInfo.roomCode,
              hasLobby: true
            })
          })
          setMode('lobby')
          return
        }

        setChannel(tempChannel)

        switch (serverUser.alias) {
          case 'server-va':
            setMode('videoArmageddon')
            break
          case 'server-fireworks':
            setMode('fireworks')
            break
          case 'server-ssc':
            setMode('startStopContinue')
            break
          case 'server-ufd':
            setMode('upForDiscussion')
            break
          case 'server-ttaal':
            setMode('twoTruthsAndALie')
            break
          case 'server-vc':
            setMode('vibeCheck')
            break
          case 'server-em':
            setMode('emojiMirror')
            break
          case 'server-ip':
            setMode('impaintient')
            break
          case 'server-qi':
            setMode('quietro')
            break
          case 'server-pa':
          case 'server-pal':
            setMode('playAlong')
            break
          default:
        }
        setClientInfo(newClientInfo)
      }
    })
  }
  if (channel === undefined) {
    return (
      <>
        <JoinView
          // mode={mode} clientInfo={clientInfo}
          joinRoom={joinRoom}
        />
        <ErrorModal
          isOpen={errorMessage !== null}
          onClose={() => {
            setErrorMessage(null)
          }}
        >
          {errorMessage}
        </ErrorModal>
      </>
    )
  }

  switch (mode) {
    case 'login':
      return (
        <>
          <JoinView
            // mode={mode}
            // clientInfo={clientInfo}
            joinRoom={joinRoom}
          />
          <ErrorModal
            isOpen={errorMessage !== null}
            onClose={() => {
              setErrorMessage(null)
            }}
          >
            {errorMessage}
          </ErrorModal>
        </>
      )
    case 'lobby':
      return <LobbyView />
    case 'fireworks':
      return <FireworksView />
    case 'startStopContinue':
      return <StartStopContinueView />
    case 'twoTruthsAndALie':
      return <TwoTruthsAndALie />
    case 'upForDiscussion':
      return <UpForDiscussionView />
    case 'vibeCheck':
      return <VibeCheck />
    case 'emojiMirror':
      return <EmojiMirror />
    case 'impaintient':
      return <Impaintient />
    case 'playAlong':
      return <PlayAlong channel={channel} playerName={playerName} />
    case 'quietro':
      return <Quietro />
    case 'videoArmageddon':
      if (playerName === 'director') {
        return <VideoArmageddonDirector />
      } else {
        return <VideoArmageddon channel={channel} />
      }
      break

    default:
  }
}

const styles = {
  container: {
    maxW: { base: 'calc(100%)', md: '500px' },
    p: '20px',
    mx: { base: 'auto', md: 'auto' },
    flex: 1,
    backgroundColor: '#fff',
    justifyContent: 'center',
    flexDir: 'column',
    height: 'calc(100dvh - 59px)',
    maxHeight: '-webkit-fill-available',
    label: {
      mr: '0',
      mb: '12px',
      fontSize: '18px',
      fontWeight: 'bold'
    }
  },

  joinRoom: {
    input: {
      // textTransform: 'uppercase'
    }
  },
  inputWrapper: {
    input: {
      fontSize: '18px',
      fontWeight: '700',
      border: '2px solid',
      borderRadius: 0,
      borderColor: 'yellow.400',
      background: 'yellow.200',
      pr: '40px'
    },
    '.bend': {
      position: 'absolute',
      bg: 'white',
      bottom: '0px',
      right: '0px',
      borderStyle: 'solid',
      h: 'auto',
      aspectRatio: '1/1',
      w: '5%',
      boxShadow: '0px 2px 0px 0px white, 2px 0px 0px 0px white',
      transition: 'all 0.5s',
      zIndex: 2,
      overflow: 'hidden',
      '&:after': {
        pointerEvents: 'none',
        color: 'yellow.100',
        background:
          'linear-gradient(135deg, currentcolor calc(50% - 1px), rgba(232,232,232,1) 50%, rgba(255,255,255,0) 50.2%, rgba(255,255,255,0) 100%)',
        content: '""',
        display: 'block',
        pos: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      button: {
        pos: 'absolute',
        right: '20px',
        bottom: '20px'
      }
    },
    '&:hover': {
      transitionDelay: '.1s',
      borderColor: 'yellow.400'
    },
    '&:hover .bend': {
      w: '8%'
    }
  }
}

export { Page }
